import * as React from "react";

export default function Application(props: any) {
  React.useEffect(() => {}, []);

  return props.children;
}
